import { Stack } from '@ui-components/neo.tax';

import { useAscContext } from '@neo.tax/asc/context';
import { useAscProjectTeamMembers, type AscProject } from '@neo.tax/asc/hooks';
import { useKeywordSearch, ProjectTeamMembersTable } from '@neo.tax/shared';

import { AscProjectTeamMembersToolbar } from '../asc-project-team-members-toolbar';
import { useAscTeamMembersTableColumns } from './hooks';

interface AscProjectTeamMembersProps {
  ascProject: AscProject;
}

export const AscProjectTeamMembers = ({ ascProject }: AscProjectTeamMembersProps): React.ReactElement => {
  const { searchKeyword, setSearchKeyword } = useKeywordSearch();
  const { fiscalYearId, periodName } = useAscContext();

  const {
    ascProjectTeamMembers: teamMembers,
    fetchMore,
    isLoadingMore,
    loading: loadingTeamMembers,
  } = useAscProjectTeamMembers({
    ascProjectId: ascProject.id,
    fiscalYearId,
    periodName,
    searchKeyword,
    hasAllocation: true,
    debounceKey: 'GET_PROJECT_TEAM_MEMBERS_WITH_ALLOCATIONS_KEY',
    numElementsPerFetch: 30,
  });
  const { columns } = useAscTeamMembersTableColumns({ ascProject, teamMembers });

  return (
    <Stack direction="column" fullHeight>
      <AscProjectTeamMembersToolbar
        ascProject={ascProject}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
      />
      <ProjectTeamMembersTable
        columns={columns}
        teamMembers={teamMembers}
        endReached={fetchMore}
        loadingRows={loadingTeamMembers}
        loadingFooter={isLoadingMore}
      />
    </Stack>
  );
};
